import { Buffer } from 'buffer'

// 为全局环境添加 Buffer
window.Buffer = Buffer

// 确保全局对象存在
if (typeof window.global === 'undefined') {
  window.global = window
}

// 添加 process.env 对象
if (typeof window.process === 'undefined') {
  window.process = { env: {} } as any
}
